import { Flex } from '@chakra-ui/layout';
import { AutocompleteInput, Button, MaskInput, Unform, AuthorizeView, TextInput } from 'components';
import { internalAreaOptions } from 'constants/demand';
import React, { memo, useCallback, useEffect, useState, ReactNode } from 'react';
import { detailsSolicitationClientValidationSchema } from 'yupSchemas/detailsSolicitationClient';
import { useBoolean } from 'hooks/useBoolean';
import { openNotification } from 'utils/notification';
import { editClientDemand } from 'services/editDemand';
import { IClientDemand } from 'types/demands';
import { formatDateToUs } from 'utils/date';
import { getLawyers, Lawyer } from 'services/lawyers';
import { checkPermission } from 'utils/authentication';

interface IProps {
  id: number | string;
  initialData: {
    areaInterna?: typeof internalAreaOptions[0];
    lawyer?: Lawyer;
    horas?: string;
    valor?: string;
  };
  data?: IClientDemand;
  children?: ReactNode;
}

const AdditionalFormComponent: React.FC<IProps> = ({ id, initialData, data: demand, children }) => {
  const [isSaving, setIsSaving] = useBoolean(false);

  const [lawyerOptions, setLawyerOptions] = useState<Lawyer[]>([]);
  const handleSubmit = useCallback(async formData => {
    if (!demand) return;
    setIsSaving(true);
    try {
      const data = {
        prazo: formatDateToUs(demand.prazo + ''),
        serviceType: {
          id: demand.serviceType,
        },
        tipoAvaliacao: demand.tipoAvaliacao || undefined,
        tipoConsulta: demand.tipoConsulta || undefined,
        consumoHoras: demand.consumoHoras,
        demanda: demand.demanda,
        descricaoTrabalho: demand.descricaoTrabalho,
        prazoAtendimento: demand.prazoAtendimento,
        // areaInterna: { id: formData.areaInterna },
        areaInterna: formData.areaInterna,
        status: demand.status,
        lawyer: { id: formData.lawyer },
        horas: formData.horas,
        valor: formData.valor,
        createdAt: demand?.createdAt ? formatDateToUs(demand?.createdAt) : undefined,
      } as any;
      const fd = new FormData();
      fd.append(
        'documentosConsultasDto',
        new Blob([JSON.stringify(data)], { type: 'application/json' }),
      );
      await editClientDemand(id + '', fd);
      openNotification('Dados salvos com sucesso!');
      history.back();
    } catch (err) {}
    setIsSaving(false);
  }, []);

  const getDataLawyers = async () => {
    const { data } = await getLawyers();
    setLawyerOptions(data);
  };

  useEffect(() => {
    checkPermission({ onlyAdmin: true }) && getDataLawyers();
  }, []);

  return (
    <>
      <Flex>
        <Unform
          onSubmit={handleSubmit}
          validationSchema={detailsSolicitationClientValidationSchema}
          initialData={initialData}
        >
          <Flex gridGap=".5rem" direction="column">
            <AuthorizeView onlyAdmin>
              <Flex gridGap="1rem">
                <Flex flex="1">
                  <AutocompleteInput
                    label="Área interna"
                    optionLabel="name"
                    optionValue="id"
                    name="areaInterna"
                    options={internalAreaOptions}
                    placeholder="Selecione..."
                  />
                </Flex>

                <Flex flex="1">
                  <AutocompleteInput
                    label="Advogado"
                    name="lawyer"
                    optionLabel="name"
                    optionValue="id"
                    options={lawyerOptions}
                    maxHeightSuggestion={12}
                    placeholder="Selecione..."
                  />
                </Flex>

                <Flex flex="1">
                  {/* <MaskInput
                    parseToFloat
                    name="horas"
                    mask="float"
                    label="Horas"
                    placeholder="Qtd. de horas"
                  /> */}
                  <TextInput
                    style={{ border: '1px solid #ccc' }}
                    name="horas"
                    type="text"
                    label="Horas"
                    placeholder="000:00:00"
                    maxLength={9}
                    onKeyPress={(ev: any) => {
                      const timer = ev.target;
                      if (timer.value.length === 9) {
                        timer.value = timer.value.slice(0, 8);
                      }
                      if (timer.value.length === 3 || timer.value.length === 6) {
                        timer.value += ':';
                      }

                      if (Number(timer.value[4]) > 5) {
                        timer.value = timer.value.slice(0, 4);
                      }
                      if (Number(timer.value[7]) > 5) {
                        timer.value = timer.value.slice(0, 7);
                      }
                      if (Number(timer.value[8])) {
                        timer.value = timer.value.slice(0, 8);
                      }
                    }}
                  />
                </Flex>

                <Flex flex="1">
                  <MaskInput
                    style={{ border: '1px solid #ccc' }}
                    parseToFloat
                    name="valor"
                    mask="currency"
                    label="Valor"
                    placeholder="R$ 0,00"
                  />
                </Flex>
              </Flex>
            </AuthorizeView>
            {children}
            <AuthorizeView onlyAdmin>
              <Flex justifyContent="space-between">
                <Button onClick={() => window.history.back()} type="button" outline>
                  Cancelar
                </Button>
                <Button isLoading={isSaving} type="submit">
                  Salvar
                </Button>
              </Flex>
            </AuthorizeView>
          </Flex>
        </Unform>
      </Flex>
    </>
  );
};

export const AdditionalForm = memo(AdditionalFormComponent);
